import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import getQuery from '../../helpers/api/get-query'
import type MessageBar from '../../types/api/message-bar'
import Strapi, { type Filters } from '../../types/strapi/strapi'

export const messageBarApi = createApi({
    reducerPath: 'messageBarApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    endpoints: builder => ({
        getMessageBars: builder.query<Strapi<MessageBar>, Filters>({
            query: filters => getQuery('/message-bars')({ filters }),
        }),
    }),
})

export const { useGetMessageBarsQuery } = messageBarApi